module.exports = __webpack_public_path__ + "img/three3Orange.84901882.jpg";